import { render, staticRenderFns } from "./RowLink.vue?vue&type=template&id=2775ae58&"
import script from "./RowLink.vue?vue&type=script&lang=ts&"
export * from "./RowLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports